export const addFavoriteLabel = "n4d";
export const newFavoritePickedText = "o4d";
export const renameFavoriteLabel = "p4d";
export default {addFavoriteLabel,newFavoritePickedText,renameFavoriteLabel};